import { DrawerHeader, DrawerHeaderTitle, DrawerBody, DrawerFooter, Button, Input, Label, tokens, OverlayDrawer, Subtitle2, Checkbox, Body1Strong, RadioGroup, Radio, InfoLabel } from "@fluentui/react-components";
import { CircleMultipleConcentricFilled, Dismiss24Regular } from "@fluentui/react-icons";
import { useCallback, useState } from "react";

export default function NewRingDrawer(
    {
        open,
        setOpen,
        createRingCallback
    }: {
        open: boolean,
        setOpen: React.Dispatch<React.SetStateAction<boolean>>,
        createRingCallback: (
            name: string
        ) => void
    }
) {
    const [ ringName, setRingName ] = useState("");

    const createRing = useCallback(
        () => {
            createRingCallback( ringName );
            setOpen(false);
        },
        []
    );

    return (
        <>
            <OverlayDrawer modalType="modal" open={open} onOpenChange={( _, d ) => setOpen(d.open)} size="medium" position="end">
                <DrawerHeader>
                    <DrawerHeaderTitle
                        action={
                            <Button
                                appearance="subtle"
                                aria-label="close"
                                icon={<Dismiss24Regular />}
                                onClick={() => setOpen(false)}
                            />
                        }>
                        <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                            <CircleMultipleConcentricFilled /> New Ring
                        </div>
                    </DrawerHeaderTitle>
                </DrawerHeader>
                <DrawerBody>
                    <Label htmlFor="new-ring-dialog-input" style={{ fontWeight: tokens.fontWeightSemibold }}>Name</Label>
                    <Input placeholder="Name" type="text" style={{ width: "100%" }} id="new-ring-dialog-input" defaultValue="Example Ring" />

                    <div style={{ marginTop: "1rem" }}>
                        <Subtitle2>
                            Access Control
                        </Subtitle2>
                        
                        <div style={{ marginTop: "0.5rem" }}>
                            <Checkbox id="new-ring-public-access" label={
                                <InfoLabel htmlFor="new-ring-public-access"
                                           label="Allow public access to this ring"
                                           info={
                                            <div>
                                                This ring will be accessible to all unauthenticated clients. Default rings cannot be private.
                                            </div>
                                           } />
                            } defaultChecked={true} />
                        </div>

                        <div style={{ marginTop: "0.5rem" }}>
                            <Body1Strong>Restrict access to:</Body1Strong>
                            <RadioGroup disabled>
                                <Radio label="All users of [DOMAIN_NAME]" defaultChecked={true} />
                                <Radio label="Specific user groups in [DOMAIN_NAME]" />
                                <Radio label="Specific users of [DOMAIN_NAME]" />
                            </RadioGroup>
                        </div>
                    </div>
                </DrawerBody>
                <DrawerFooter>
                    <Button appearance="primary" onClick={createRing}>
                        Create
                    </Button>
                </DrawerFooter>
            </OverlayDrawer>
        </>
    );
}